import { Button, Modal } from "@payping/web-components";
import { loggedOut } from "@payping/redux/actions";
import { webConstants } from "@payping/utils/platformConstants";
import { safeJoinPath } from "@payping/utils/string";
import * as Sentry from "@sentry/react";
import React, { useEffect, useState } from "react";
import { useAsyncFn } from "react-use";
import { useNavigate } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "@/utils/redux";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { removeLottieLoading } from "@/utils";

const Logout: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const token = useAppSelector((state) => state.auth.token);
  const [tmpToken, setTmpToken] = useState<string>(token);
  const [loading, setLoading] = useState<boolean>(false);
  const { t } = useAppTranslation();
  const { AUTH_URL } = webConstants;

  useEffect(() => {
    removeLottieLoading();
    if (token) setTmpToken(token);
  }, [token]);

  const [, handleLogout] = useAsyncFn(async () => {
    setLoading(true);
    // to erase and oidc from browser storage
    localStorage.clear();
    sessionStorage.clear();

    // remove sentry data
    Sentry.configureScope((scope) => scope.setUser(null));

    // remove token from redux
    dispatch(loggedOut());

    // redirect to logout page
    // TODO: this method should be changed in backend to be a POST method, then, it should be moved to api package
    window.location.assign(
      safeJoinPath(AUTH_URL.replace(".ir", ".io"), `/Account/FrontLogout?clientid=PayPingWebApp&token=${tmpToken}`)
    );
  });

  return (
    <div>
      <Modal
        open
        title={t("profileMenu.logoutModal.title")}
        footer={
          <>
            <Button variant={"outline"} onClick={() => navigate(-1)} loading={loading}>
              {t("no")}
            </Button>
            <Button variant={"primary"} danger onClick={handleLogout} loading={loading}>
              {t("yes")}
            </Button>
          </>
        }
      >
        {t("profileMenu.logoutModal.text")}
      </Modal>
    </div>
  );
};

// Inject the Params provided by React Router into connected components
export default Logout;
